import Backbone from 'backbone';


const JoinosCode = Backbone.Model.extend({
    letter_url(){
        return `/joinos/joinos_codes/?format=latex&pk=${this.get('id')}`;
    },
    cancel_url(){
        return `/joinos/joinos_codes/${this.get('id')}/cancel/`;
    }
});

export default JoinosCode;



// WEBPACK FOOTER //
// ./joinos_codes/models/code.js